"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubmitHandler = void 0;
function getSubmitHandler(url, initialValues, getBody) {
    return function (values, { setStatus, setValues, setTouched }) {
        return __awaiter(this, void 0, void 0, function* () {
            function resetForm() {
                setValues(initialValues);
                setTouched({});
                setStatus(true);
            }
            if (process.env.NODE_ENV !== 'production') {
                yield new Promise(resolve => {
                    setTimeout(resolve, 2000);
                });
                resetForm();
                return;
            }
            try {
                const response = yield fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(getBody ? getBody(values) : values),
                });
                if (!response.ok) {
                    throw response;
                }
                resetForm();
                return response;
            }
            catch (error) {
                console.error(error);
            }
        });
    };
}
exports.getSubmitHandler = getSubmitHandler;
